import styled from '@emotion/styled'
import PropTypes from 'prop-types'

import style from './Matterport.style'

const MatterportStyled = styled.div(props => ({ ...style(props) }))

const Matterport = ({ matterportLink }) => {
    return (
        <MatterportStyled>
            <div className="wp-block-embed is-type-video">
                <div className="wp-block-embed__wrapper">
                    <iframe
                        width="100%"
                        height="100%"
                        src={matterportLink}
                        frameBorder="0"
                        allowFullScreen=""
                        allow="xr-spatial-tracking"
                        title="Matterport"
                    />
                </div>
            </div>
        </MatterportStyled>
    )
}

Matterport.propTypes = {
    matterportLink: PropTypes.string.isRequired
}

export default Matterport
